export const getDate = (date: Date | undefined, withTime: boolean = true) => {
    if (!date) {
        return ''
    }
    let currentDate = date.toLocaleDateString()
    let currentTime = new Date(date).toLocaleTimeString()
    currentDate = currentDate.replace('.', "/").replace('.', "/")
    const arr = currentTime.split(':')
    let hours = parseInt(arr[0])
    let midnight = hours >= 12 ? "PM" : "AM"
    if (navigator.platform.indexOf('Mac') > -1) {
       midnight = '' 
    }
    if (hours > 12) {
        hours = hours - 12
    }
    currentTime = hours.toString() + ":" + arr[1] + ":" + arr[2] + " " + midnight
    
    return !withTime ? currentDate : currentDate + " " + currentTime
}

export const getDateForPicker = (date: Date) => {
    const currentDate = Date.parse(date.toDateString());

    if (isNaN(currentDate)) {
      return "-"
    }
    const dateTime = date.toLocaleDateString()
    const dateArray = dateTime.split('.')
    const resultDate = dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0]
    let hour = date.getHours().toString()
    let minute = date.getMinutes().toString()
    let numberSeconds = date.getSeconds()
    let seconds = numberSeconds === 0 ? '1' : numberSeconds.toString()
    seconds = seconds.length === 1 ? '0' + seconds : seconds
    hour = hour.length === 1 ? '0' + hour : hour
    minute = minute = minute.length === 1 ? '0' + minute : minute
    const result = resultDate + 'T' + hour + ':' + minute + ':' + seconds
    return result
}

export const transformDateForInputValue = (dateString:string|undefined)=>{
    const date = new Date(dateString||"");
    const day = date.getDate()<=9?`0${date.getDate()}`:date.getDate();
    const month = date.getMonth()<=9?`0${date.getMonth()}`:date.getMonth();
    const year = date.getFullYear();

    return `${year}-${month}-${day}`
}